import React, { useState, useEffect } from "react";

export function DateTimeSelector({ value, onChange }) {
  const [minDateTime, setMinDateTime] = useState("");

  useEffect(() => {
    const now = new Date();
    const localISOTime = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 16);
    setMinDateTime(localISOTime);
    
    // Set initial value if not provided
    if (!value) {
      onChange(localISOTime);
    }
  }, []);

  return (
    <div className="datetime-selector-container">
      <input
        type="datetime-local"
        id="datetime-input"
        className="datetime-input"
        value={value || minDateTime}
        onChange={(e) => onChange(e.target.value)}
        min={minDateTime}
      />
    </div>
  );
}